export interface CarPart {
  ProductType: string;
  OEcode: string;
  OEprice: string;
  Currency: string;
  DateTarif: string;
  ArcautoCode: string;
  ADAS: string;
  Sensor: string;
  FittingTime: string;
  TotalTime: string;
  Description: string;
}
